import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/auth/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success("If the email exists, a reset link has been generated.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="Enter your email to receive a password reset link.">
      {sent ? (
        <div className="rounded-xl border border-sky-200 bg-sky-50 p-6 text-sm text-slate-600" data-testid="forgot-sent-card">
          If an account exists for <strong>{email}</strong>, a reset token has been generated.
          Email delivery is disabled in this environment — check backend logs for the token, then
          continue to <Link to="/reset-password" className="font-semibold text-sky-600 hover:underline">reset password</Link>.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label>Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full rounded-full bg-slate-900 hover:bg-slate-800">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
          </Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-slate-500">
        <Link to="/login" className="font-semibold text-sky-600 hover:underline">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
